"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var tld = 'authereum.com';
exports.defaultConfig = {
  apiUri: function apiUri(network) {
    var s = network === 'mainnet' ? '' : "".concat(network, ".");
    return "https://".concat(s, "api.").concat(tld);
  },
  rpcUri: function rpcUri(network) {
    return "https://".concat(network, ".rpc.").concat(tld);
  },
  webUri: function webUri(network) {
    var s = network === 'mainnet' ? '' : "".concat(network, ".");
    return "https://".concat(s).concat(tld);
  },
  xsUri: function xsUri(network) {
    var s = network === 'mainnet' ? '' : "".concat(network, ".");
    return "https://".concat(s, "x.").concat(tld);
  },
  networkId: function networkId(network) {
    return {
      'mainnet': 1,
      'ropsten': 3,
      'rinkeby': 4,
      'kovan': 42,
      'goerli': 5
    }[network] || 1;
  }
};
exports.blocknativeDappId = 'fccf560b-943a-45e9-9af3-6b19e44e167e';